import { render, staticRenderFns } from "./adminGroupOrder.vue?vue&type=template&id=4beb53e6&scoped=true"
import script from "./adminGroupOrder.vue?vue&type=script&lang=js"
export * from "./adminGroupOrder.vue?vue&type=script&lang=js"
import style0 from "./adminGroupOrder.vue?vue&type=style&index=0&id=4beb53e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb53e6",
  null
  
)

export default component.exports